import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import { ROLES } from "@/lib/auth/roles";
import DateFilter from "@/lib/filters/date/date-filter";
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import { performanceByAdviserQueryOptions } from "@/modules/general-performance/hooks/hooks";
import {
  GeneralPerformaceSearch,
  mergedGenetalPerformanceSchema
} from "@/types/route-search-schemas";
import { DataLoader } from "@/types/router-context";
import { PERFORMANCE_BY_ADVISER_PATH } from "@/utils/urls";
import PerformanceByAdviser from "src/modules/general-performance";

export const Route = createFileRoute( PERFORMANCE_BY_ADVISER_PATH )(
  {
    component: AdviserPerformanceGeneralPerformance,
    validateSearch: (search: Record<string, unknown>): GeneralPerformaceSearch => validateSearchWithDefaults(mergedGenetalPerformanceSchema, search),
    loader: ({ context: {queryClient, date, } } :DataLoader) => {
      if (!isCurrentPage(PERFORMANCE_BY_ADVISER_PATH)) {
        // Load Data...
        queryClient.prefetchQuery(performanceByAdviserQueryOptions(date))
      }
    },
    beforeLoad: () => {
      return {
        breadcrumbs: [
          { label: 'Adviser performance', path: '#' },
          { label: 'General Performance', path: '/' },
        ],
        children: <>
          <DateFilter />
        </>
      }
    }
  })

function AdviserPerformanceGeneralPerformance() {
  return <div className={'flex flex-col items-center justify-center'}>
    <Authorisation
      roles={[ROLES.ROLE_VIEW_ADVISER, ROLES.ROLE_VIEW_FIRM]}
      permissions={[]}
      forbiddenFallback={<Unauthorized/>}
    >
      <PerformanceByAdviser />
    </Authorisation>
  </div>
}
